import { StatCard } from "@/ui/StatCard";
import { type LucideIcon } from "lucide-react";
import { cn } from "@/nucleo/utilitarios";

export interface StatItem {
  title: string;
  value: string | number;
  icon: LucideIcon;
  description?: string;
  trend?: { value: number; label: string };
  className?: string;
  href?: string;
  onClick?: () => void;
  active?: boolean;
}

interface StatsGridProps {
  stats: StatItem[];
  /** Grid columns config. Default: "grid-cols-2 md:grid-cols-4" */
  columns?: string;
  className?: string;
}

export function StatsGrid({ stats, columns = "grid-cols-2 md:grid-cols-4", className }: StatsGridProps) {
  return (
    <div className={cn("grid gap-4", columns, className)}>
      {stats.map((stat, i) => (
        <StatCard
          key={i}
          title={stat.title}
          value={stat.value}
          icon={stat.icon}
          description={stat.description}
          trend={stat.trend}
          className={stat.className}
          href={stat.href}
          onClick={stat.onClick}
          active={stat.active}
        />
      ))}
    </div>
  );
}
